var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownLayta = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.307 4.721 2.293 9.743a.92.92 0 0 0-.293.694q0 .415.293.693l.577.585q.285.285.694.285c.272 0 .5-.095.7-.285L8 7.972l3.744 3.743q.284.285.693.285c.272 0 .5-.095.7-.285l.578-.585a.94.94 0 0 0 .285-.694.94.94 0 0 0-.285-.693L8.701 4.721a.99.99 0 0 0-.7-.285.94.94 0 0 0-.694.285"
})));
export default SvgArrowDownLayta;